<template>
  <div>
    <section class="content-section nearby-professionals">
      <div class="container">
        <span class="section-title">
          <h1 class="text-center md:text-left">{{ title }}</h1>
        </span>
        <div v-if="localProfessionals.length > 0">
          <hooper
            :settings="hooperSettings"
            :infinite-scroll="localProfessionals.length > 1"
            :auto-play="true"
            :play-speed="4000"
            :trimWhiteSpace="true"
            style="display: inline-grid"
          >
            <slide v-for="(professional, indx) in localProfessionals" :key="indx" :index="indx">
              <ProfessionalsCard :professional="professional" />
            </slide>
            <hooper-pagination slot="hooper-addons" />
          </hooper>
        </div>
        <div v-else>
          <h2 class="my-4">Nenhum Profissional Encontrado.</h2>
          <h3>
            Seja o primeiro profissional cadastrado na sua região.
            <strong>
              <router-link to="/signup">Cadastre-se</router-link>
            </strong> agora mesmo.
          </h3>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {
  Hooper,
  Slide,
  Pagination as HooperPagination
} from 'hooper'
import ProfessionalsCard from './ProfessionalsCard'
import * as firebase from 'firebase/app'
import { professionalsGeoCollection, firestore } from '../../firebaseConfig'
import { mapState } from 'vuex'

const DEBUG = process.env.NODE_ENV === 'development'

export default {
  components: {
    Hooper,
    Slide,
    ProfessionalsCard,
    HooperPagination
  },
  props: {
    breakpoints: Object,
    professionals: Array,
    title: String,
    location: String,
    maxDistance: Number,
    queryType: String,
    professionalId: String
  },
  data () {
    return {
      localProfessionals: [],
      hooperSettings: {
        itemsToShow: 1,
        wheelControl: false,
        breakpoints: this.breakpoints || {
          425: {
            itemsToShow: 2
          },
          852: {
            itemsToShow: 3
          },
          1440: {
            itemsToShow: 4
          }
        }
      }
    }
  },
  computed: {
    ...mapState(['locationName'])
  },
  methods: {
    async getAllProfessionals () {
      try {
        this.localProfessionals = []

        DEBUG && console.log('All Professionals')

        const docs = await professionalsGeoCollection
          .limit(24)
          .get()

        docs.forEach(doc => {
          this.localProfessionals.push(doc.data())
        })
      } catch (error) {
        DEBUG && console.error(error)
      }
    },
    async getNearbyProfessionals () {
      this.localProfessionals = []

      try {
        const { lat, lng } = await this.$getLocation()

        DEBUG && console.log('Nearby', { lat, lng })

        const docs = await professionalsGeoCollection
          .near({
            center: new firebase.firestore.GeoPoint(lat, lng),
            radius: this.maxDistance || 50
          })
          .limit(24)
          .get()

        docs.forEach(doc => {
          this.localProfessionals.push(doc.data())
        })
      } catch (error) {
        DEBUG && console.error(error)
      }
    },
    async getProfessionalsByGeoPoint (professionalId) {
      this.localProfessionals = []
      try {
        const doc = await firestore.collection('professionals').doc(professionalId).get()
        const data = await doc.data()
        const geopoint = data.l

        const docs = await professionalsGeoCollection
          .near({
            center: geopoint,
            radius: this.maxDistance || 50
          })
          .limit(24)
          .get()

        docs.forEach(doc => {
          this.localProfessionals.push(doc.data())
        })
      } catch (error) {
        DEBUG && console.error(error)
      }
    }
  },
  async mounted () {
    DEBUG && console.log('Query Type', this.queryType)
    switch (this.queryType) {
      case 'professionalId':
        await this.getProfessionalsByGeoPoint(this.professionalId)
        break
      case 'location':
        await this.getNearbyProfessionals()
        break
      case 'all':
        await this.getAllProfessionals()
        break
      default:
        await this.getAllProfessionals()
    }
  },
  watch: {
    async locationName () {
      console.log('watch ', this.locationName)
      await this.getNearbyProfessionals()
    }
  }
}
</script>
